import clsx from "clsx";
import React, { FunctionComponent } from "react";
import { useTranslation } from "react-i18next";

import { useNullableDealerAccountInfo } from "../../../../../stores/hooks/useNullableDealerAccountInfo";
import { usePanelState } from "../../../../../stores/hooks/usePanelState";
import { Checkbox } from "../../../../../ui/Checkbox/Checkbox";
import { Collapsible } from "../../../../../ui/CollapsiblePannel/Collapsible";
import { PriceDisplay } from "../../../../../ui/PriceDisplay/PriceDisplay";
import { useTirePriceOptions } from "./useTirePriceOptions";
import { useTirePricing } from "./useTirePricing";

const id = "dealer-tire-price-panel";

export const TirePriceFilters: FunctionComponent = () => {
  const [panelIsOpen, togglePanel] = usePanelState(id, false);
  const { t } = useTranslation();
  const [, togglePrice] = useTirePricing();
  const options = useTirePriceOptions();
  const dealer = useNullableDealerAccountInfo();
  if (!dealer?.dealerProductFilters.pricingFilter) {
    return null;
  }
  return (
    <Collapsible
      className=" space-y-2"
      id={id}
      label={t("searchResults.pricing")}
      onToggle={togglePanel}
      visible={panelIsOpen}
    >
      {options.map(({ checked, count, range: [min, max], value }) => (
        <label
          className={clsx("flex gap-x-4", !count && "opacity-40")}
          key={value}
        >
          <Checkbox
            onChange={(): void => {
              togglePrice(value);
            }}
            checked={checked}
            checkedClassName="text-selected-tab"
            disabled={count === 0}
            name="brand"
          />
          <span className="flex-1">
            <PriceDisplay>{min}</PriceDisplay>
            {max === Infinity ? (
              "+"
            ) : (
              <span>
                {" "}
                &ndash; <PriceDisplay>{max}</PriceDisplay>
              </span>
            )}
          </span>
        </label>
      ))}
    </Collapsible>
  );
};
